import Cookies from 'js-cookie'
import Splide from '@splidejs/splide';

const COOKIE_NAME = 'AsideMessageCarouselClosed'
const EL_SELECTOR = '.js-AsideMessageCarousel'
const EL = document.querySelector(EL_SELECTOR)
const COOKIE_EXPIRES_DAYS = 7

class AsideMessageCarousel {
  constructor() {
    if(!Cookies.get(COOKIE_NAME) && EL){
      this.init()
      this.show()
    }
  }

  show = () => {
    EL.classList.remove('not-loaded')
  }

  setCloseCookie = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: COOKIE_EXPIRES_DAYS })
  }

  init = () => {
    const close = EL.querySelector('.aside-message__close')

    let updateHeight = newIndex => {
      let slide = slider.Components.Slides.getAt( typeof( newIndex ) == 'number' ? newIndex : slider.index ).slide;
      slide.parentElement.parentElement.style.height = slide.offsetHeight + 'px';
    };

    let slider = new Splide( EL, {
      arrows: false,
      pagination: true,
      perMove: 1,
      autoHeight: true,
      autoplay: true,
      interval: 10000,
    } ).mount()
    .on( 'move', updateHeight );
    updateHeight();

    close.addEventListener('click', (e) => {
      const button = e.currentTarget
      const parent = button.closest(EL_SELECTOR)

      this.setCloseCookie()

      parent.classList.add('is-hidden')
    })
  }
}

new AsideMessageCarousel();
